import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { IUser } from '@core/models/interfaces/user.interface';
import { CoreStore } from '@core/store/core.store';
import { userRetrieved$ } from '@core/store/core-store.utils';

export const sessionUserResolver: ResolveFn<IUser | undefined> = () => {
  const coreStore = inject(CoreStore);

  return userRetrieved$().pipe(
    map(() => coreStore.user())
  );
};
